import React from 'react';
import './styles.scss';
import { Form, Col, Row } from 'react-bootstrap';
import { Button } from '@material-ui/core';
import { FontAwesome } from '..';

const FormSetting: React.FC = () => {
  return (
    <>
      <div className="container-form-setting">
        <Form>
          <Col className="container-body">
            {/* TODO: Show this field when type user is admin. [AR] */}
            <Form.Label>Tipo de cobrança *</Form.Label>
            <Form.Control className="form-control" />
            <Form.Label>Taxa cobrada por frete *</Form.Label>
            <Form.Control className="form-control" />

            <h5>Campos da distruibuidora</h5>

            <Form.Label>E-mail</Form.Label>
            <Form.Control className="form-control" />
            <Form.Label>Nome</Form.Label>
            <Form.Control className="form-control" />
          </Col>
          <Row className="container-buttons" noGutters>
            <Button className="primary-button outline">Cancelar</Button>
            <Button className="success-button icon-left">
              <FontAwesome name="save" type="far" classname="fa-lg" />
              Salvar
            </Button>
          </Row>
        </Form>
      </div>
    </>
  );
};

export default FormSetting;
